import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Button, Header, Segment } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import { useField } from "formik";
import * as Yup from 'yup';
import MyTextInputBasic, {MyTextInput} from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import { MySelectInput, valor, MySelectInputEdiciones } from "../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { CuotasMod, CuotasModFormValues } from "../../app/models/CuotasMod";
import { TiposCuentas } from "../../app/common/options/TiposCuentas";
import { createCATCursos } from "../../app/models/CATCursos";
import { number } from "yup/lib/locale";
import { Check } from "@material-ui/icons";
import { PassMod, PassModFormValues } from "../../app/models/PassWord";
import RecuperarUsuario from "./RecuperarUsuario";

interface Props {
    correo: string;
}

export default observer(function RecuperarPassword(props: Props) {

    const [condicion, setCondicion] = useState(false)
    const history = useHistory();
    const [aplica, setAplica] = useState(false);


    const { PassStore, modalStore } = useStore();

    const { passRecuperar, loading } = PassStore;
    //const {CATCoursesInfo,testing} = CuotasStore;

    const [PassMod] = useState<PassModFormValues>(new PassModFormValues());

    const validationSchema = Yup.object({
        email: Yup.string().required('Obligatorio'),

    })

    function handleFormSubmit(PassMod: PassModFormValues) {
        let newPass: PassMod = {
            email: PassMod.email,

        };

        passRecuperar(newPass).then(() => {
            toast.success("Se envió correctamente.")
            toast.success("Revise la bandeja de entrada de su correo electrónico")
            modalStore.closeModal()
        });
    }

    if (PassStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (

        <div className="modal_pago_cur modal-reset-password">

            <div className="modal_pago_head">
                <h1>Recuperar contraseña</h1>
            </div>

            <Formik validationSchema={validationSchema}
                enableReinitialize
                initialValues={{email: props.correo}}
                onSubmit={values => handleFormSubmit(values)}>
                {({ handleSubmit, isValid, isSubmitting, dirty }) => (

                    <Form onSubmit={handleSubmit} autoComplete='off' className="contenido_modal_pago">

                        <p>Ingresa el correo electrónico que registraste en la plataforma</p>

                        <MyTextInput className="reset-input" name='email' placeholder='tu-correo@servicio.com' type="email" defaultValue={props.correo} />

                        <div className="botones_pago_modal">
                            <Button
                                loading={loading}
                                type='submit'
                                content='Enviar'
                                className="primary"
                            />
                        </div>

                    </Form>
                )}
            </Formik>
            <div className='recuperar-contraseña recuperar-usuario'>
                <p>¿Olvidaste tu usuario?</p>
                <a onClick={() => modalStore.openModal(<RecuperarUsuario padre={"RecuperarContraseña"} />, 'mini')}>
                    Recuperar usuario
                </a>
            </div>
        </div>

    )
})
